export default __webpack_public_path__ + "static/media/school_marker.e67ac13c.svg";